import { render, staticRenderFns } from "./templatePage.vue?vue&type=template&id=2ca6de3d&scoped=true"
import script from "./templatePage.vue?vue&type=script&lang=js"
export * from "./templatePage.vue?vue&type=script&lang=js"
import style0 from "./templatePage.vue?vue&type=style&index=0&id=2ca6de3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6de3d",
  null
  
)

export default component.exports